import styled from '@emotion/styled';

const Wrapper = styled('div')({
  marginBottom: '6.5rem',
  marginTop: '1.5rem',
  textAlign: 'center',
});

export default Wrapper;
